<div class="auth-page">
  <!-- Left Side - Branding -->
  <div class="auth-hero">
    <div class="auth-hero__icons">
      <i class="pi pi-building hero-icon hero-icon--1"></i>
      <i class="pi pi-chart-bar hero-icon hero-icon--2"></i>
      <i class="pi pi-briefcase hero-icon hero-icon--3"></i>
      <i class="pi pi-bolt hero-icon hero-icon--4"></i>
      <i class="pi pi-cog hero-icon hero-icon--5"></i>
      <i class="pi pi-chart-line hero-icon hero-icon--6"></i>
      <i class="pi pi-box hero-icon hero-icon--7"></i>
      <i class="pi pi-truck hero-icon hero-icon--8"></i>
      <i class="pi pi-wallet hero-icon hero-icon--9"></i>
      <i class="pi pi-file hero-icon hero-icon--10"></i>
      <i class="pi pi-users hero-icon hero-icon--11"></i>
      <i class="pi pi-globe hero-icon hero-icon--12"></i>
    </div>
    <div class="auth-hero__content">
      <img src="assets/icon/meine-kommune-logo.svg" alt="Meine Kommune" class="auth-hero__logo" />
      <h1 class="auth-hero__title">Meine Kommune Business Hub</h1>
      <p class="auth-hero__subtitle">Nachhaltige Lösungen für Ihr Unternehmen. Verwalten Sie Ihre Energie, optimieren Sie Prozesse und erreichen Sie Ihre Klimaziele.</p>
    </div>
    <div class="auth-hero__footer">
      <span>Meine Kommune</span>
    </div>
  </div>

  <!-- Right Side - Register Card -->
  <div class="auth-card">
    <div class="auth-card__scroll">
      <!-- Mobile Header -->
      <div class="auth-card__mobile-header">
        <img src="assets/icon/meine-kommune-logo.svg" alt="Meine Kommune" class="auth-card__mobile-logo" />
        <p class="auth-card__mobile-brand">Meine Kommune</p>
        <h1 class="auth-card__mobile-title">Business Hub</h1>
      </div>

      <h2 class="auth-card__heading">Registrieren</h2>
      <p class="auth-card__subheading">Erstelle dein Konto um loszulegen</p>

      <form [formGroup]="registerForm" (ngSubmit)="performRegistration()">
        <div class="auth-field">
          <label>E-Mail</label>
          <input type="email" placeholder="name@beispiel.de" formControlName="email" autocomplete="email"/>
        </div>

        <div class="auth-field">
          <label>Passwort</label>
          <div class="auth-field__password">
            <input [type]="showPassword ? 'text' : 'password'" placeholder="Passwort erstellen" formControlName="password" autocomplete="new-password" (keyup.enter)="performRegistration()"/>
            <button type="button" (click)="showPassword = !showPassword">
              <i [class]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
            </button>
          </div>
        </div>

        <ul class="password-hints">
          <li [class.valid]="hasUppercase(registerForm.get('password')?.value)">
            <i [class]="hasUppercase(registerForm.get('password')?.value) ? 'pi pi-check' : 'pi pi-times'"></i>
            Mindestens ein Großbuchstabe
          </li>
          <li [class.valid]="hasLowercase(registerForm.get('password')?.value)">
            <i [class]="hasLowercase(registerForm.get('password')?.value) ? 'pi pi-check' : 'pi pi-times'"></i>
            Mindestens eine Zahl
          </li>
          <li [class.valid]="hasMinLength(registerForm.get('password')?.value, 8)">
            <i [class]="hasMinLength(registerForm.get('password')?.value, 8) ? 'pi pi-check' : 'pi pi-times'"></i>
            Mindestens 8 Zeichen
          </li>
        </ul>

        <button type="submit" class="auth-btn" [disabled]="isRegisterInitiated">
          <span *ngIf="!isRegisterInitiated">Registrieren</span>
          <i *ngIf="isRegisterInitiated" class="pi pi-spinner pi-spin"></i>
        </button>
      </form>

      <div class="auth-divider"><span>oder</span></div>

      <a routerLink="/auth/login" class="auth-btn auth-btn--outline">Zurück zur Anmeldung</a>
    </div>
  </div>
</div>
